// French translation file for the i18n module
import { TranslateDto } from "../translate.dto";

export const fr: TranslateDto = {
  // Not found Page
  Not_found_page: "404: Page non trouvée",
  //Global
  Go_back: "Retour à l'accueil",
  // Topbar
  Slogan: "Les seules lunettes 100% personnalisables",
  // PutPostCode
  Error_PERMISSION_DENIED:
    "L'utilisateur a refusé la permission de géolocalisation.",
  Error_POSITION_UNAVAILABLE:
    "Les informations de localisation ne sont pas disponibles.",
  Error_TIMEOUT: "Le délai de la demande a expiré.",
  Error_UNKNOWN_ERROR: "Une erreur inconnue s'est produite.",
  Error_default: "Une erreur inconnue s'est produite.",
  Search_your_optic: "Recherchez votre opticien le plus proche",
  Description_for_search_optic:
    "Entrez votre adresse et nous chercherons les opticiens les plus proches de vous ",
  Alert: "Il semble y avoir un problème",
  Placeholder_search_optic: "Entrez votre adresse ou code postal",
  Can_I_Have_Your_Ubication: "Puis-je avoir votre localisation?",
  Description_We_Need_Ubication:
    "Pour trouver l'opticien le plus proche de vous, vous devez me permettre d'accéder à votre localisation",
  Confirm: "Oui, bien sûr!",
  Denaied: "Non, merci",
  Cant_Accesses_Your_Ubication:
    "Désolé, je ne peux pas accéder à votre localisation",
  Description_Cant_Accesses_Your_Ubication:
    "Il semble que vous ayez refusé l'accès à votre localisation. Pour trouver l'opticien le plus proche de vous, vous devez entrer votre adresse ou code postal dans le champ ci-dessus",
  Accept: "D'accord",
  Search_GPS: "Recherche GPS...",
  Use_My_Location: "Utiliser ma localisation actuelle",
  No_Selection_Location: "Vous n'avez sélectionné aucune adresse",
  Search: "Rechercher",
  Ofert1: "Achetez vos lunettes FLiPO à -15% dto. + Bon de réduction de 50€",
  // Ubication
  Go_to_the_list: "Retour à la liste",
  This_is_your_optics: "Voici vos opticiens les plus proches:",
  Description_We_Need_Ubication2:
    "Entrez votre adresse dans le champ de recherche ci-dessus pour voir votre opticien le plus proche",
  Not_Found_Optics: "Oups...! Il n'y a pas d'opticiens près de chez vous",
  Form_to_contact: "Vous pouvez également nous contacter par",
  Distance: " Km de distance",
  Ask_date: "PRENDRE RENDEZ-VOUS",
  // CardOptic
  Optic_nearest: "C'est votre magasin le plus proche",
  Of_distance: " de distance",
  See_map: "Voir la carte",
  // Schedule
  Ofert2:
    "Prenez rendez-vous et obtenez une réduction et un examen visuel gratuit!",
  PostCode_banner_promo:
    "Prenez rendez-vous et obtenez une réduction ainsi qu'un examen visuel gratuit !",
  Choose_optic: "Opticien choisi:",
  Direction: "Adresse:",
  Selected_day: "Sélectionnez un jour:",
  Schedule_subtitle: "Cliquez sur l'heure de la journée où vous souhaitez essayer vos FLiPO sans engagement et avec un examen visuel gratuit",
  Choose_hour: "Choisissez une heure pour votre rendez-vous:",
  Load_more_days: "Charger plus de jours",
  No_search_schedules: "Oups...! Il n'y a pas de rendez-vous disponibles",
  Change_optic: "Changer d'opticien",
  See_more: "Voir plus",
  Try_another_week: "Vous pouvez également essayer une autre semaine",
  // Hours Container
  No_schedule: "Il n'y a plus de rendez-vous",
  // Client Data
  Form_title: "Remplissez vos informations pour réserver le rendez-vous",
  Receive_ofert: "Vous recevrez votre offre par email et WhatsApp",
  Your_choose_optic: "Votre opticien choisi:",
  Your_choose_date: "Votre date choisie:",
  Name: "Nom",
  Subname: "Prénom",
  Phone: "Téléphone",
  Email: "Email",
  Incorrect_field: "Champ incorrect *",
  Next: "Suivant",
  // Confirmation
  Error_create_appointment:
    "Une erreur s'est produite lors de la création du rendez-vous.",
  Error_update_appointment:
    "Une erreur s'est produite lors de la mise à jour du rendez-vous.",
  Error_active_appointment_title: "Vous avez déjà un rendez-vous actif",
  Error_active_appointment_desc:
    "Vous ne pouvez pas réserver un autre rendez-vous tant qu'un rendez-vous actif est en attente. Si vous devez le modifier, contactez votre opticien ou modifiez-le depuis l'e-mail que vous avez reçu lors de la réservation.",
  Edit_your_data: "Modifiez vos informations pour changer le rendez-vous",
  Confirm_for_reserve:
    "Rendez-vous confirmé avec succès",
  Change_my_optic: "Changer mon opticien",
  Change_my_date: "Changer ma date",
  changeMyData: "Changer mes informations",
  Your_data: "Vos informations de contact:",
  Confirm_appointment: "Confirmer le rendez-vous",
  Edit_my_data: "Modifier mes informations",
  Greetings: "Bonjour",
  Of: "de",
  Await_you: "vous attendra le jour",
  At: "à",
  If_put: "Si vous portez des lentilles",
  No_24h: "ne les portez pas pendant les 24h",
  Pre_exam: "précédant l'examen",
  Is_easy: "C'est très facile d'arriver à:",
  Benefit_appointment_title: "Pendant le rendez-vous:",
  Benefit_appointment_1: "Nous vérifions gratuitement",
  Benefit_appointment_2:
    "Vous pourrez essayer une large sélection de couleurs et d'accessoires",
  Benefit_appointment_3:
    "Vous verrez quel modèle de nos lunettes s'adapte le mieux à votre visage",
  Benefit_appointment_4:
    "Vous pourrez consulter votre opticien sur les clips dont vous avez besoin",
  Free: "Tout est gratuit!",
  Remember:
    "N'oubliez pas qu'avec votre rendez-vous réservé, vous n'aurez pas à faire la queue, et en plus, simplement en assistant,",
  Promotion: "vous pourrez profiter de 15% de réduction et du cadeau surprise",
  No_assist:
    "Si vous ne pouvez pas assister ou si vous avez des questions, vous pouvez nous contacter via",
  Or: "ou",
  Start: "Accueil",
  Until_the: "Jusqu'au",
  // Landing Page
  Landing_header: "DÉCOUVREZ NOTRE COLLECTION D'ACCESSOIRES",
  Landing_hero_banner_title_1: "PRENEZ RENDEZ-VOUS ET",
  Landing_hero_banner_title_2: "OBTENEZ VOS FLiPO",
  Landing_hero_banner_subtitle: "EXAMEN GRATUIT ET EN QUELQUES MINUTES",
  Landing_hero_title_1: "VOTRE EXAMEN VISUEL, ",
  Landing_hero_title_2: "GRATUIT",
  Landing_hero_title_3: "ET EN MINUTES",
  Landing_form_subtitle: "Vous êtes à un clic de découvrir les",
  Landing_form_subtitle_highlight: "lunettes modulaires qui changent avec vous",
  Landing_form_name_label: "Nom*",
  Landing_form_phone_label: "Téléphone*",
  Landing_form_lastname_label: "Nom de famille*",
  Landing_form_email_label: "Email*",
  Landing_form_postcode_label: "Code postal*",
  Landing_form_postcode_placeholder: "Recherchez votre adresse ou code postal",
  Landing_form_button: "RÉSERVEZ VOTRE RENDEZ-VOUS GRATUIT",
  Landing_form_no_thanks: "Je ne veux pas graduer mes lunettes",
  Landing_form_disclaimer: "*Vos données ne seront utilisées que pour coordonner le rendez-vous. Nous ne partagerons jamais d'informations.",
  Landing_glasses_title_1: "ADAPTEZ VOS FLiPO",
  Landing_glasses_title_2: "À TOUT MOMENT DE LA JOURNÉE",
  Landing_glasses_solar_title: "Protection Solaire",
  Landing_glasses_solar_desc: "Verre polarisé US10 avec UV400 pour réduire l'éblouissement. Protégez-vous de l'exposition solaire.",
  Landing_glasses_dreamred_title: "DreamRed",
  Landing_glasses_dreamred_desc: "Verre de repos. Les verres rouges bloquent 100% de la lumière bleue et 60% de la lumière verte, favorisant la production naturelle de lumière.",
  Landing_glasses_screen_title: "Protection d'Écran",
  Landing_glasses_screen_desc: "Réduit les reflets, vous garde clair et améliore le contraste entre l'écran et l'environnement. Augmente contre la lumière bleue.",
  Landing_glasses_night_title: "Conduite nocturne",
  Landing_glasses_night_desc: "Verre polarisé V75 Enhanced avec UV400 qui permet une vision sans reflets, réduisant les éblouissements.",
  Landing_color_banner_title: "AJOUTEZ DE LA COULEUR ET DU STYLE À VOS LUNETTES",
  Landing_color_banner_text: "Changez les clips et les branches pour que vos lunettes s'accordent avec votre tenue, votre humeur ou l'occasion.",
  Landing_color_banner_button: "PRENEZ RENDEZ-VOUS",
  Landing_final_banner_title_1: "Et vous,",
  Landing_final_banner_title_2: "quel FLiPO choisissez-vous?",
  Landing_newsletter_title: "Abonnez-vous à notre Newsletter",
  Landing_newsletter_subtitle: "Découvrez toutes nos offres et nouveautés",
  Landing_newsletter_email_placeholder: "Adresse e-mail",
  Landing_newsletter_checkbox: "J'ai lu et j'accepte la Politique de Confidentialité et les Termes et Conditions",
  Landing_newsletter_country_label: "Pays/région",
  Landing_social_title: "Suivez-nous sur nos réseaux",
  Landing_footer_plan: "Plan d'abonnement",
  Landing_footer_faqs: "FAQ",
  Landing_footer_shipping: "Expéditions et Retours",
  Landing_footer_payment: "Mode de Paiement",
  Landing_footer_gift: "Cartes Cadeau",
  Landing_footer_contact: "Contact",
  Landing_footer_jobs: "Travaillez avec nous",
  Landing_copyright: "© Copyright 2025. FLiPO.",
  Landing_copyright_rights: "Tous droits réservés.",
  Landing_privacy: "Politique de confidentialité et cookies",
  Landing_shipping_policy: "Politique d'expédition",
  Landing_terms: "Termes et conditions",
  Landing_contact_info: "Informations de contact",
  Landing_legal_notice: "Avis légal",
  // Loading & Error screens
  Loading_searching_optic: "Recherche de votre opticien...",
  Loading_moment: "Cela ne prendra qu'un instant",
  Creating_appointment: "Nous créons votre rendez-vous...",
  Error_optic_not_found: "Opticien non trouvé",
  Error_optic_not_found_desc: "Nous n'avons pas pu trouver l'opticien avec le code fourni. Veuillez vérifier le lien ou rechercher un opticien à proximité.",
  Error_network: "Erreur de connexion",
  Error_network_desc: "Impossible de se connecter au serveur. Veuillez vérifier votre connexion internet et réessayer.",
  Error_unknown: "Une erreur s'est produite",
  Error_unknown_desc: "Une erreur inattendue s'est produite. Veuillez réessayer ou rechercher un opticien à proximité.",
  Error_search_nearby: "Rechercher un opticien à proximité",
  Error_retry: "Réessayer",
  Error_go_home: "Retour à l'accueil",
  // FAQs
  Question_1: "De quoi sont faites les lunettes FLiPO?",
  Answer_1:
    "Tous nos produits sont fabriqués avec un matériau pionnier pour sa flexibilité et sa résistance, connu sous le nom d'ULTEM. Pour plus d'informations, vous pouvez consulter la fiche technique de chaque modèle de lunettes",
  Question_2: "Comment fonctionnent les clips et les branches?",
  Answer_2:
    "Les clips et les branches fonctionnent grâce à un système magnétique qui permet de les appliquer facilement et en toute sécurité sans craindre qu'ils ne se détachent.",
  Question_3:
    "Quelle est la différence entre le clip fonctionnel et le clip de design?",
  Answer_3:
    "Le clip fonctionnel combine l'aide visuelle des verres correcteurs, et grâce aux différentes fonctionnalités, transforme vos lunettes et protège de la lumière bleue, du soleil et des différents rayons qui peuvent affecter votre vue. En revanche, le clip de design change l'apparence de la face avant de la monture et, avec l'échange des branches, permet de changer complètement le style des lunettes.",
  Question_4: "Quand mes FLiPO monofocales seront-elles prêtes?",
  Answer_4:
    "Vos lunettes seront prêtes en 7-10 jours ouvrables. Et ensuite, profitez-en!",
  Question_5: "Quand mes FLiPO progressives seront-elles prêtes?",
  Answer_5:
    "Vos lunettes seront prêtes en 7-10 jours ouvrables. L'attente en vaut la peine!",
};
